<template>
  <div class="station-page">
    <sidebar/>
    <div class="content">
      <div class="content-body">
        <div class="content-header">
          <div class="content-header-content">
              <div class="content-body-header">{{$t(selectMenu.title)}}</div>
          </div>
        </div>
        <div class="body-container" v-if="selectMenu.path === 'dashboard' || selectMenu.path === 'sysinformation' || selectMenu.path === 'liveupdate' || $router.currentRoute.name === 'debug'">
          <div class="side-bar-tab" v-if="selectMenu && selectMenu.submenu && Object.keys(selectMenu.submenu).length > 1">
            <div class="m-web-tab" :key="menu.path" v-for="menu in selectMenu.submenu" @click="onMenuClick(menu)" :class="{'show-tab': (subMenu.path===menu.path)}">
              {{$t(menu.title)}}
            </div>
          </div>
          <router-view></router-view>
        </div>
        <div class="body-container" v-else>
          <div class="content-body-deviceinfo" :class="{open_d: !deviceCollapsed, close_d: deviceCollapsed}">
            <device-info/>
          </div>
          <div class="content-body-content" :class="{open_d: !deviceCollapsed, close_d: deviceCollapsed}">
            <div class="router-content">
              <div class="side-bar-tab" v-if="selectMenu && selectMenu.submenu">
                <!--&& Object.keys(selectMenu.submenu).length > 1-->
                <div class="m-web-tab" :key="menu.path" v-for="menu in selectMenu.submenu" @click="onMenuClick(menu)" :class="{'show-tab': (subMenu.path===menu.path)}">
                  {{$t(menu.title)}}
                </div>
                <div class="how-to-btn" @click="onHelpClick" :class="{hide: showQuickHelp}">
                  <div class="icon-setting_1" />
                  <div class="title">{{$t('menu.howto')}}</div>
                </div>
              </div>
              <router-view></router-view>
            </div>
            <div class="helper-content" :class="{open_h: showQuickHelp, close_h: !showQuickHelp}">
              <how-to />
            </div>
          </div>
        </div>
      </div>
    </div>
    <about/>
    <popup-confirm name="firmware-auto-modal" :dialog-header="$t('updatefw.autoFwTitle')" :dialog-message="modalContent1" :dialog-message2="$t('updatefw.autoFwContent1')" :dialog-message3="$t('updatefw.autoFwContent2')" :dialog-message4="$t('updatefw.autoFwContent3')" :dialog-message5="$t('updatefw.autoFwContent4')" icon="w" type="u" :callback="goUpdate" :onlyOk="false" />
    <popup-call-back name="ubifs-warning-modal" type="o" :dialog-header="$t('errorMessage.restoreSystemError')" :dialog-message="$t('errorMessage.systemDestroyed')" icon="w" :onlyOk="true" :callback="onOkClick" />
    <info-tips v-if="showInfoTips" ref="infoTips"/>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Sidebar from './Sidebar'
import About from './About'
import DeviceInfo from './DeviceInfo'
import HowTo from './HowTo'
export default {
  name: 'station-page',
  components: {
    Sidebar,
    About,
    DeviceInfo,
    HowTo
  },
  data () {
    return {
      liveFW: null,
      sysErr: null
    }
  },
  created: function () {
    let me = this
    this.$log.info('created')
    this.getSystemError().then((res) => {
      let result = null
      if (res.data.result) result = res.data.result[0].error
      if (result) {
        me.sysErr = result
        me.openModal('ubifs-warning-modal')
        me.$modal.show('ubifs-warning-modal')
      } else {
        me.autoCheckLiveUpdate()
      }
    })
  },
  methods: {
    onToggleClick () {
      this.$store.commit(
        'setSidebarCollapsed',
        !this.$store.state.app.sidebarCollapsed
      )
    },
    onMenuClick: function (menu) {
      if (this.$router.currentRoute.name !== menu.path) {
        this.$store.commit('updateNextMenu', menu)
        if (this.isDataChanged) {
          this.$store.commit('updateIsSidebar', false)
          this.openModal('warning-window-modal')
          this.$modal.show('warning-window-modal')
        } else {
          this.$store.commit('updateSubMenu', menu)
          this.$router.push({
            name: menu.path
          })
          this.$store.commit('updateIsSidebar', null)
        }
      }
    },
    onHelpClick: function () {
      this.$store.commit('updateQuickHelp', !this.showQuickHelp)
    },
    onDeviceClick: function () {
      this.$store.commit('updatedeviceCollapsed', !this.deviceCollapsed)
    },
    onLogout: async function () {
      this.$store.commit('setLoadingType', 'logout')
      this.$store.commit('updateFullLoadingStatus', true)
      await this.postLogout()
    },
    async autoCheckLiveUpdate () {
      let haveDNS = false
      await this.getDNSConfig()
        .then((response) => {
          if (response.data.result && response.data.result.length > 0) {
            let tempList = response.data.result
            let result = false
            if (tempList[0].val.IpAddress !== '') {
              result = true
            }
            haveDNS = result
          } else {
            haveDNS = false
          }
        })
      if (haveDNS && !this.systemHostInfo.Product.includes('M5216')) {
        await this.checkLiveUpdate()
          .then((res) => {
            if (res && res.data.error_code === 200) {
              this.liveFW = res.data.result
              if (this.liveFW.newer) {
                this.openModal('firmware-auto-modal')
                this.$modal.show('firmware-auto-modal')
              }
            }
          }).catch((err) => {
            this.$log.error(err)
            // this.$modal.show('warn-modal')
            // this.openModal('warn-modal')
          })
      }
    },
    goUpdate () {
      this.closeModal('firmware-auto-modal')
      this.$modal.hide('firmware-auto-modal')
      this.$store.commit('setUpdateStatus', true)
      this.$store.commit('updateFileStatus', false)
      this.$store.commit('setUpdateType', 'live')
      this.postLiveUpload()
        .then((res) => {
          this.$log.debug(res)
        }).catch((error) => {
          this.$log.error(error)
        })
    },
    onOkClick () {
      this.setSystemError(this.sysErr)
      this.closeModal('ubifs-warning-modal')
      this.$modal.hide('ubifs-warning-modal')
      this.autoCheckLiveUpdate()
    },
    ...mapActions(['auth', 'postLogout', 'getDNSConfig', 'checkLiveUpdate', 'postLiveUpload', 'getSystemError', 'setSystemError']),
    ...mapMutations(['openModal', 'closeModal'])
  },
  mounted: function () {
  },
  beforeMount: function () {
  },
  computed: {
    path: function () {
      return this.$store.state.route.path
    },
    localStorageName () {
      return 'QPACS' + this.$store.state.app.showQuickStartSuffix
    },
    modalContent1 () {
      let isNew = (this.liveFW) ? this.liveFW.newer : false
      let result = (isNew) ? this.$t('about.version') + ': ' + this.liveFW.version + '.' + this.liveFW.number + ' ' + '(' + this.liveFW.buildNumber + ')' : this.$t('updatefw.alreadyUpdate')
      return result
    },
    ...mapState({
      selectMenu: state => state.app.selectMenu,
      subMenu: state => state.app.subMenu,
      isDataChanged: state => state.app.isDataChanged,
      showHelper: state => state.app.showHelper,
      showInfoTips: state => state.app.showInfoTips,
      showQuickHelp: state => state.app.showQuickHelp,
      deviceCollapsed: state => state.app.deviceCollapsed,
      systemHostInfo: state => state.module.systemHostInfo
    })
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.station-page {
  height: calc(100% - 60px);
  width: 100%;
  display: flex;
  > .content {
    flex: 1;
    height: 100%;
    padding: 10px 20px 20px 10px;
    >.content-body {
      background: #f2f2f2;
      border-radius: 8px;
      padding: 20px 10px 10px 10px;
      > .content {
        background: #ffffff;
        height: calc(100% - 40px);
        &.dashboard {
          background: initial;
        }
      }
      > .content-header {
        display: block;
        margin: 0px 0px 20px 10px;
        user-select: none;
        color: #000000;
        .content-header-content {
          display: flex;
          width: 100%;
          margin-top: 0px;
        }
        .content-body-header {
          line-height: 20px;
          display: block;
          font-size: 20px;
          font-weight: 900;
          line-height: 20px;
        }
        .content-body-subheader {
          margin-left: 10px;
          display: block;
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
        }
      }
      >.body-container{
        height: calc(100% - 40px);
        >.content-body-deviceinfo {
          height: 240px;
          margin-bottom: 5px;
          transition: height .6s;
          &.open_d {
            height: 240px;
          }
          &.close_d {
            height: 40px;
          }
        }
        >.content-body-content {
          height: calc(100% - 245px);
          display: flex;
          transition: height .6s;
          &.open_d {
            height: calc(100% - 245px);
          }
          &.close_d {
            height: calc(100% - 45px);
          }
          >.router-content {
            height: 100%;
            color: #000000;
            flex: 2;
            > .container {
              padding: 15px 15px;
            }
            > .content {
              background: #ffffff;
              height: 100%;
              border-bottom-left-radius: 8px;
              border-bottom-right-radius: 8px;
              &.dashboard {
                background: initial;
              }
            }
            > .content-tab {
              background: #ffffff;
              height: calc(100% - 40px);
              overflow: overlay;
              &.dashboard {
                background: initial;
              }
            }
          }
          >.helper-content {
            border-radius: 8px;
            transition: min-width .6s ease, max-width .6s ease;
            background: #ffffff;
            &.open_h {
              flex: 1;
              min-width: 300px;
              max-width: 300px;
              margin-left: 5px;
            }
            &.close_h {
              flex: 0;
              min-width: 0px;
              max-width: 0px;
              margin-left: 0px;
            }
          }
        }
        > .content {
          background: #ffffff;
          height: 100%;
          &.dashboard {
            background: initial;
          }
        }
        > .content-tab {
          background: #ffffff;
          height: calc(100% - 40px);
          overflow: overlay;
          &.dashboard {
            background: initial;
          }
        }
      }
    }
  }
}
.select-action {
  text-align: center;
  margin-top: 10px;
  position: relative;
  bottom: 0px;
  width: 100%;
}
.open {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 1 !important;
  z-index: 6000 !important;
}
.side-bar-tab {
  user-select: none;
  background: #ffffff;
  height: 40px;
  display: flex;
  width: auto;
  padding: 0px;
  line-height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 16px;
  border-bottom: 2px solid #e6e6e6;
  position: relative;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.m-web-tab {
  font-family: 'Roboto-R' !important;
  overflow: hidden;
  width: auto;
  padding: 0 25px;
  line-height: 40px;
  color: #000000;
  bottom: -2px;
  position: relative;
  cursor: pointer;
  &:hover {
    border-bottom: 2px solid #000000;
  }
  &.show-tab {
    font-family: 'Roboto-B' !important;
    color: #1A8EC7;
    border-bottom: 2px solid #1A8EC7;
  }
}
.how-to-btn {
  position: absolute;
  right: 10px;
  margin-top: 9px;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: flex-start;
  .icon-setting_1 {
    width: 20px;
    font-size: 20px;
    margin-right: 5px;
  }
  .title {
    flex: 1;
  }
  &:hover {
    .title {
      color: #000FFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StationPage.vue